import { formatValidationMessage } from '@/common/application/utils/fieldNameFormatter';

/**
 * Maps backend validation field names to ERP form field names
 * The ERP form uses slightly different field names than the traditional form
 */
const ERP_FIELD_NAME_MAP: Record<string, string> = {
  LeaveTime: 'leaveByTime', // ERP form uses 'leaveByTime' instead of 'leaveTime'
  OnJobTime: 'onJobTime',
  StartTime: 'startTime',
  ShowUpTime: 'showUpTime'
};

/**
 * Maps a backend validation field name to its corresponding ERP Formik field name
 * @param backendFieldName - The field name from backend validation errors (e.g., "LeaveTime")
 * @returns The corresponding ERP Formik field name (e.g., "leaveByTime") or the lowercase version if no mapping exists
 */
export const mapERPBackendFieldToFormikField = (backendFieldName: string): string => {
  return ERP_FIELD_NAME_MAP[backendFieldName] || backendFieldName.toLowerCase();
};

export interface BackendValidationError {
  field: string;
  message: string;
}

/**
 * Maps backend validation errors to ERP Formik field errors
 * @param validationErrors - Array of validation errors from backend
 * @returns Object with ERP Formik field names as keys and error messages as values
 */
export const mapERPValidationErrorsToFormikErrors = (validationErrors: BackendValidationError[]): Record<string, string> => {
  const formikErrors: Record<string, string> = {};

  for (const error of validationErrors) {
    const formikFieldName = mapERPBackendFieldToFormikField(error.field);
    // Format the error message to be more user-friendly
    formikErrors[formikFieldName] = formatValidationMessage(error.message, error.field);
  }

  return formikErrors;
};
